//@flow
import React from 'react';
import {Button, IconButton, makeStyles} from '@material-ui/core';
import {Close, Crop} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';

export type Props = {
  src: string,
  isSelected?: boolean,
  selectedLabel?: string,
  onRemove?: () => void,
  onCrop?: () => void,
  onClick?: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: 132,
    height: 132,
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '.95rem',
    border: '3px solid transparent',
    '&[data-selected="true"]': {
      border: `3px solid ${colors.primary}`,
    },
  },
  imageButton: {
    width: '100%',
    height: '100%',
    padding: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  cropButton: {
    position: 'absolute',
    color: colors.primary,
    background: colors.lightPurple,
    padding: '.4rem',

    right: '.25rem',
    bottom: '.35rem',

    '&[data-selected="true"]': {
      right: 'initial',
      bottom: 'initial',
      top: '.25rem',
      left: '.25rem',
    },
  },

  removeButton: {
    padding: '.4rem',
    position: 'absolute',
    color: '#033149',
    backgroundColor: '#fff',
    top: '.25rem',
    right: '.25rem',
  },
  posterLabel: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    padding: '.5rem',
    backgroundColor: colors.primary,
    color: '#fff',
    textAlign: 'center',
    fontWeight: 600,
  },
}));

export default function ImageItem(props: Props) {
  const {src, isSelected, onCrop, onRemove, onClick, selectedLabel} = props;

  const classes = useStyles();

  return (
    <div className={classes.root} data-selected={isSelected}>
      <Button
        className={classes.imageButton}
        onClick={onClick}
        disabled={!onClick}
      >
        <picture className={classes.image}>
          <img src={src} alt="product" />
        </picture>
      </Button>
      {onCrop && (
        <IconButton
          onClick={onCrop}
          className={classes.cropButton}
          data-selected={isSelected}
        >
          <Crop fontSize="small" />
        </IconButton>
      )}

      {onRemove && !isSelected && (
        <IconButton
          onClick={onRemove}
          className={classes.removeButton}
          data-selected={isSelected}
        >
          <Close fontSize="small" />
        </IconButton>
      )}

      {isSelected && selectedLabel && (
        <div className={classes.posterLabel}>{selectedLabel}</div>
      )}
    </div>
  );
}
